import {
  useDialogHeading
} from "./MEP5WKMB.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";

// src/popover/popover-heading.ts
var usePopoverHeading = createHook((props) => {
  props = useDialogHeading(props);
  return props;
});
var PopoverHeading = createComponent(
  (props) => {
    const htmlProps = usePopoverHeading(props);
    return createElement("h1", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  PopoverHeading.displayName = "PopoverHeading";
}

export {
  usePopoverHeading,
  PopoverHeading
};
